<template>
  <span class="copyable-text">
    <span
      class="copyable-value"
      :class="{
        'copyable-value-code': code,
        'copyable-value-mono': mono || code,
        'copyable-value-strong': strong
      }"
    >
      {{ displayText }}
    </span>
    <Tooltip v-if="canCopy" content="复制" transfer>
      <span
        class="copyable-action"
        role="button"
        tabindex="0"
        @click.stop="handleCopy"
        @keydown.enter.stop="handleCopy"
      >
        <Icon type="md-copy" size="14" />
      </span>
    </Tooltip>
  </span>
</template>

<script>
import { copyText } from '@/libs/util'

export default {
  name: 'CopyableText',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    code: {
      type: Boolean,
      default: false
    },
    mono: {
      type: Boolean,
      default: false
    },
    strong: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    canCopy() {
      return (
        this.value !== null &&
        this.value !== undefined &&
        this.value !== '' &&
        this.value !== '-'
      )
    },
    displayText() {
      return this.canCopy ? this.value : '-'
    }
  },
  methods: {
    handleCopy() {
      if (this.canCopy) copyText(String(this.value))
    }
  }
}
</script>

<style scoped lang="less">
.copyable-text {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  gap: 5px;
  vertical-align: middle;
}

.copyable-value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.copyable-value-mono {
  font-family: Consolas, Monaco, monospace;
  font-size: 13px;
}

.copyable-value-code {
  padding: 0 4px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #f5f5f5;
  line-height: 20px;
}

.copyable-value-strong {
  font-weight: 600;
}

.copyable-action {
  flex: none;
  color: #8c8c8c;
  line-height: 1;
  cursor: pointer;
  transition: color 0.2s;

  &:hover,
  &:focus {
    color: #1677ff;
    outline: none;
  }
}
</style>
